import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { curriculum } from "../mock/mock";
import { SectionHeading } from "./SectionHeading";
import SmartImage from "./SmartImage";

const slugs = ["pre-kg-upper-kg", "grades-1-2", "grades-3-7"];

export default function Curriculum() {
  return (
    <section id="curriculum" className="py-24 lg:py-32" style={{ background: "var(--cream)" }}>
      <div className="mx-auto max-w-[1280px] px-5 lg:px-6">
        <SectionHeading
          eyebrow="Academics at KPR"
          title="Curriculum design, stage by stage"
          sub="A CBSE spine with a KPR soul — play in the foundational years, structure in the preparatory years, and real-world projects through middle school."
          align="center"
        />

        <div className="mt-16 grid gap-7 lg:grid-cols-3">
          {curriculum.map((c, i) => (
            <article
              key={c.title}
              data-reveal=""
              style={{ transitionDelay: `${i * 110}ms`, border: "1px solid rgba(11,59,54,.09)" }}
              className="group flex flex-col overflow-hidden rounded-2xl bg-white"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px)";
                e.currentTarget.style.boxShadow = "0 34px 70px -40px rgba(8,46,41,.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "none";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div className="relative h-[230px] overflow-hidden">
                <SmartImage
                  src={c.image}
                  fallback={c.fallback}
                  alt={c.title}
                  className="h-full w-full object-cover group-hover:scale-105"
                  style={{ transition: "transform .8s cubic-bezier(.22,1,.36,1), opacity .6s ease" }}
                />
                <span
                  className="absolute left-5 top-5 rounded-full px-4 py-1.5 text-[0.68rem] font-bold tracking-[0.14em] uppercase"
                  style={{ background: "var(--cream)", color: "var(--teal-800)" }}
                >
                  {c.badge}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-8">
                <h3 className="font-display text-[1.5rem]" style={{ color: "var(--teal-900)" }}>
                  {c.title}
                </h3>
                <p className="mt-4 text-[0.9rem] leading-relaxed" style={{ color: "var(--muted-ink)" }}>
                  {c.text}
                </p>

                <ul className="mt-6 space-y-2.5">
                  {c.points.map((p) => (
                    <li key={p} className="flex items-start gap-2.5 text-[0.85rem]" style={{ color: "var(--teal-800)" }}>
                      <Check size={15} strokeWidth={2.6} style={{ color: "var(--gold)", marginTop: 2 }} />
                      {p}
                    </li>
                  ))}
                </ul>

                <div className="mt-8 flex-1" />
                <Link
                  to={`/academics/${slugs[i]}`}
                  className="inline-flex items-center gap-2 text-[0.8rem] font-bold tracking-[0.1em] uppercase"
                  style={{ color: "var(--gold)" }}
                >
                  Read More
                  <ArrowUpRight size={15} className="group-hover:translate-x-1 group-hover:-translate-y-1" style={{ transition: "transform .3s ease" }} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
